import { render, staticRenderFns } from "./InspectionDetails.vue?vue&type=template&id=46d3c7e1&"
import script from "./InspectionDetails.vue?vue&type=script&lang=js&"
export * from "./InspectionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports